<div class="content-wrapper">

  <section class="content-header">
    <h1>
      Visualizar Prestação de contas
      <small>Gerenciar conteúdo</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/home">
          <i class="fa fa-home"></i> Home</a>
      </li>
      <li>
        <a routerLink="/prestacao-contas">Prestação de contas</a>
      </li>
      <li class="active">Visualizar Execução</li>
    </ol>
  </section>

  <br>

  <div class="col-md-12">

    <div class="box box-primary">

      <div class="panel-body">

        <div class="col-sm-12">
          <h3><b>{{ celebracao.et1Titulo }}</b></h3>
          <hr>
        </div>

        <div class="col-sm-8">
          <div class="col-sm-12 no-padding">

            <div class="col-sm-1 text-center no-padding">
              <i class="fa fa-angle-double-right text-muted" style="font-size: 40px;"></i>
            </div>

            <div class="col-sm-11" style="border-left: solid 1px #ccc;margin-bottom: 25px;">

              <h4 style="color: #999;">Entidade:</h4>

              <h3 class="text-light-blue" style="margin-top: 0;">
                <b>{{ pthp.entidadeProponente.nome }}</b>
              </h3>
              <h4>CNPJ: <b>{{ pthp.entidadeProponente.cnpj  | mask: '00.000.000/0000-00' }}</b></h4>

              <span *ngIf="pthp.entidadeProponente.statusHabilitacao == 'Nao_habilitado'" class="badge bg-yellow"
                style="margin-top: 5px; margin-bottom: 5px; font-size: 12px">
                <b>Não Habilitada </b></span>
              <span *ngIf="pthp.entidadeProponente.statusHabilitacao == 'Aguardando_habilitacao'" class="badge bg-red"
                style="margin-top: 5px; margin-bottom: 5px; font-size: 12px">
                <b>Aguardando Habilitação</b>
              </span>
              <span *ngIf="pthp.entidadeProponente.statusHabilitacao == 'Inadimplente'" class="badge bg-red"
                style="margin-top: 5px; margin-bottom: 5px; font-size: 12px">
                <b>Inadimplente</b>
              </span>
              <span *ngIf="pthp.entidadeProponente.statusHabilitacao == 'Habilitada_parcialmente'"
                class="badge bg-yellow" style="margin-top: 5px; margin-bottom: 5px; font-size: 12px">
                <b>Habilitada Parcialmente</b></span>
              <span *ngIf="pthp.entidadeProponente.statusHabilitacao == 'Habilitada_plenamente'" class="badge bg-green"
                style="margin-top: 5px; margin-bottom: 5px; font-size: 12px">
                <b>Habilitada Plenamente</b></span>

              <h4>Gestor(a): <b>{{ pthp.entidadeProponente.chefe.nome }}</b></h4>

            </div>

          </div>

          <div class="col-sm-12 no-padding">

            <div class="col-sm-1 text-center no-padding">
              <i class="far fa-calendar text-muted" style="font-size: 25px; padding-top: 9px;"></i>
            </div>

            <div class="col-sm-11" style="border-left: solid 1px #ccc;margin-bottom: 25px;">

              <h4 style="color: #999;">Período:</h4>

              <p style="font-size: 20px; margin-top: 5px;">
                Início: <b>{{celebracao.et5PeriodoIniExecucao | date: 'dd MMM. yyyy'}}</b>
                <br>
                Término: <b>{{celebracao.et5PeriodoFimExecucao | date: 'dd MMM. yyyy'}}</b>
              </p>

            </div>
          </div>


          <div class="col-sm-12 no-padding">
            <div class="col-sm-1 text-center no-padding">
              <i class="far fa-bell text-muted" style="font-size: 25px; padding-top: 9px;"></i>
            </div>

            <div class="col-sm-11" style="border-left: solid 1px #ccc;">
              <h4 style="color: #999;">Avisos:</h4>
              <p style="font-size: 20px; margin-top: 5px;">Nenhum aviso encontrado!</p>
            </div>
          </div>

        </div>



        <div class="col-sm-4">

          <div class="col-sm-1 text-center no-padding" style="right: 10px;">
            <i class="far fa-file-alt text-muted" style="font-size: 28px; padding-top: 7px;"></i>
          </div>

          <div class="col-sm-11 no-padding" style="border-left: solid 1px #ccc;padding-left: 15px !important;">

            <h4 style="color: #999;">Informações do processo:</h4>

            <table class="table table-situacao-processo">

              <tr>
                <td><b>Valor total do projeto</b></td>
                <td class="text-right">{{valorTotalProjeto | currency: 'BRL':'symbol-narrow':'1.2-2'}}</td>
              </tr>
              <tr>
                <td><b>Repasses</b></td>
                <td class="text-right">{{repasses | currency: 'BRL':'symbol-narrow':'1.2-2'}}</td>
              </tr>
              <tr>
                <td><b>Aplicação financeira</b></td>
                <td class="text-right">{{aplicacaoFinanceira | currency: 'BRL':'symbol-narrow':'1.2-2'}}</td>
              </tr>
              <tr>
                <td><b>Contas apresentadas</b></td>
                <td class="text-right">{{contasApresentadas | currency: 'BRL':'symbol-narrow':'1.2-2'}}</td>
              </tr>
              <tr>
                <td><b>Percentual de contas atual</b></td>
                <td class="text-right">{{percentualContasAtual.toFixed(1)}}%</td>
              </tr>
              <tr>
                <td><b>70% da prestação de contas parcial</b></td>
                <td class="text-right">{{prestacaoContasParcial | currency: 'BRL':'symbol-narrow':'1.2-2'}}</td>
              </tr>
              <tr>
                <td><b>100% da prestação de contas</b></td>
                <td class="text-right">{{prestacaoContasTotal | currency: 'BRL':'symbol-narrow':'1.2-2'}}</td>
              </tr>

            </table>

          </div>

        </div>









        <div class="col-md-12">
          <br>
          <h3>Opções:</h3>
          <hr>

          <button class="btn btn-app animated fadeInDown" pTooltip="Análise de contas parcial" tooltipPosition="top"
            [routerLink]="['parcial']" routerLinkActive="btn-app-active">
            <i class="fas fa-check"></i>Parcial
          </button>
          <button class="btn btn-app animated fadeInDown" pTooltip="Análise de contas final" tooltipPosition="top"
            [routerLink]="['final']" routerLinkActive="btn-app-active">
            <i class="fas fa-check-double"></i>Final
          </button>

        </div>

        <div class="col-sm-12">
          <hr>
        </div>

        <div class="col-sm-12">
          <router-outlet (activate)="showDefaultMessage=true">
            <div class="col-sm-12" *ngIf="!showDefaultMessage">
              <h3 class="text-muted">Selecione a opção desejada.</h3>
            </div>
          </router-outlet>
        </div>

        <div class="col-sm-12">
          <hr>
        </div>

      </div>



    </div>

  </div>


</div>